import React from "react";

export default () => <div className="loader__container">
    <div className="loader__progress">
        <div className="loader" />
        <p className="text-muted mt-3 mb-0">We are logging you out.</p>
    </div>
</div>
